//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
import Global from '../../../../Services/Common/Global';
import Commons from '../../../../Services/Common/Common';
/** Components Import */
import M_TBM_CUSTOM_02 from './M_TBM_CUSTOM_02';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useSearch1 } from './M_TBM_CUSTOM_02_Query';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_CUSTOM_02F(props) {
  //#region 변수
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const [inputs, setInputs] = useState({
    video: '',
    isNext: false,
  });
  const videoRef = useRef();
  const [played, setPlayed] = useState(0);
  const [play, setPlay] = useState(false);
  //#endregion

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPlay(true);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch]);

  //#region 쿼리
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      const videoLocation = rows[0]?.videoLocation;

      if (!videoLocation) {
        setInputs({
          ...inputs,
          video: '',
          isNext: true,
        });
      } else {
        const videoFullUrl = GetFullFileUrl(videoLocation);
        setInputs((prev) => ({
          ...prev,
          video: videoFullUrl,
        }));
      }
    },
  });
  //#endregion

  //#region 나머지 함수
  const GetFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = Commons.EncodeUrl(relativePath);
    return `${Global.file.useUrl}files/${fixedPath}`;
  };

  const HandleVideoError = (e) => {
    console.log('Video Error: ', e);
    if (e.type === 'error') {
      setInputs({
        ...inputs,
        video: '',
        isNext: true,
      });
    }
  };

  const HandleVideoEnd = () => {
    setInputs({
      ...inputs,
      isNext: true,
    });
  };

  const HandleProgress = (state) => {
    setPlayed(state.played);
  };

  const HandleSeek = () => {
    if (!videoRef.current) return;
    try {
      const currentTime = videoRef.current.getCurrentTime();
      const duration = videoRef.current.getDuration();
      if (!duration || duration === 0) return;
      const playedFraction = currentTime / duration;
      if (playedFraction > played) {
        setPlayed(playedFraction);
      }
    } catch (error) {
      console.log('Seek Error: ', error);
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TBM_CUSTOM_02
        userInfo={userInfo}
        lanList={lanInfo}
        inputs={inputs}
        setInputs={setInputs}
        videoRef={videoRef}
        play={play}
        setPlay={setPlay}
        setModalToggle1={props.setModalToggle1}
        modalToggle1={props.modalToggle1}
        setModalToggle2={props.setModalToggle2}
        modalToggle2={props.modalToggle2}
        activeStep={activeStep}
        setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
        check={props.check}
        setCheck={props.setCheck}
        userCount={props.userCount}
        HandleVideoError={HandleVideoError}
        HandleVideoEnd={HandleVideoEnd}
        HandleProgress={HandleProgress}
        HandleSeek={HandleSeek}
        ActiveButton={props.ActiveButton}
      />
    </div>
  );
}

export default M_TBM_CUSTOM_02F;
